import { getUserAgent } from '@tencent/midas-util'
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-param-reassign */
/**
 * 动态加载脚本文件
 */
export function getScript(url: string, scriptCharset = 'utf-8'): Promise<Event> {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')

    script.type = 'text/javascript'
    script.onerror = reject
    script.onload = resolve
    script.src = url
    script.charset = scriptCharset
    document.body.appendChild(script)
  })
}

/**
 * 把js字面量对象序列化成url查询字符串格式
 * @param obj
 * @returns {string}
 */
export function serializeParams(obj) {
  const params = []
  for (const i in obj) {
    params.push(`${encodeURIComponent(i)}=${encodeURIComponent(obj[i])}`)
  }
  return params.join('&')
}

/**
 * ajax 请求文件
 * options.type 请求方法
 * options.dataType 请求文件类型
 * options.timeout 请求超时时间
 * options.data 请求内容
 */
export function ajax(options = {} as any) {
  const promise = new Promise((resolve, reject) => {
    options.type = (options.type || 'GET').toUpperCase()
    options.dataType = options.dataType || 'json'
    options.timeout = options.timeout || 10000

    const params = options.contentType === 'json' ? JSON.stringify(options.data) : serializeParams(options.data)
    const xhr = new XMLHttpRequest()
    xhr.responseType = options.dataType
    xhr.withCredentials = !!options.withCredentials
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        if (xhr.status >= 200 && xhr.status < 300) {
          if (xhr.responseType === 'json') {
            resolve(xhr.response)
          } else {
            resolve(JSON.parse(xhr.response))
          }
        } else {
          reject(xhr)
        }
      }
    }
    xhr.onerror = reject

    // 连接 和 发送 - 第二步
    if (options.type === 'GET') {
      xhr.open('GET', `${options.url}${params ? `?${params}` : ''}`)
      xhr.send(null)
    } else if (options.type === 'POST') {
      xhr.open('POST', options.url, true)
      // 设置表单提交时的内容类型
      xhr.setRequestHeader('Content-Type', options.requestContentType || 'application/x-www-form-urlencoded')
      xhr.send(params)
    }

    setTimeout(() => {
      if (xhr.readyState !== 4) {
        reject(new Error('ajax request timeout'))
      }
    }, options.timeout)
  })
  return promise
}
/**
 * 对象过滤器
 * arr.reduce(callback[, initialValue])
 * callback(accumulator, currentValue, currentIndex, array)
 *
 * obj 需要处理的对象
 * filterFunction 筛选的条件
 */
/* eslint-disable no-param-reassign */
/* eslint-disable no-sequences */
/* eslint-disable no-return-assign */
export function filterObject(obj: Object, filterFunction: Function): Object {
  return Object.keys(obj)
    .filter((key, index) => filterFunction(obj[key], index))
    .reduce((res, currKey) => ((res[currKey] = obj[currKey]), res), {})
}

/**
 * 获得当前的UA
 * @returns {*}
 */
export function getDeviceUA(): 'android_qq' | 'ios_qq' | 'android_wx' | 'ios_wx' {
  const ua = getUserAgent()
  if (ua.QQ && ua.android) {
    return 'android_qq'
  }

  if (ua.QQ && ua.iOS) {
    return 'ios_qq'
  }

  if (ua.weixin && ua.android) {
    return 'android_wx'
  }

  if (ua.weixin && ua.iOS) {
    return 'ios_wx'
  }

  return 'android_qq'
}
